module.exports = __webpack_public_path__ + "img/4.6fb56b7e.png";